/**
 * Image gallery in the add-on details modal, with arrows and pips.
 */
class AddOnGallery extends HTMLElement {
  connectedCallback() {
    if (this.querySelectorAll(".swiper-slide").length < 2) return;

    window.loadSwiper.then(({ Swiper, Navigation, Pagination }) => {
      if (!this.isConnected) return;

      this.swiper = new Swiper(this, {
        modules: [Navigation, Pagination],
        cssMode: true,
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: this.querySelector("[data-gallery-next]"),
          prevEl: this.querySelector("[data-gallery-previous]"),
        },
        pagination: {
          el: this.querySelector("[data-gallery-pagination]"),
          clickable: true,
        },
      });
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy();
    this.swiper = null;
  }
}

if (!customElements.get("add-on-gallery")) {
  customElements.define("add-on-gallery", AddOnGallery);
}
